/**
 * Section anchors a completed task card can jump to after it opens its page.
 * The producing service sets `TaskNavigation.section`; the frontend marks the
 * matching region with `data-task-section="<key>"`. Both sides read these keys
 * from here so a rename cannot drift between them.
 */
export const TASK_NAVIGATION_SECTION = {
    /** Per-creative results list on a Pre-Flight report. */
    PREFLIGHT_CREATIVES: 'preflight-creatives',
    /** Opportunity sets grid. */
    OPPORTUNITY_SETS: 'opportunity-sets',
    /** Completed-scripts tab inside an opportunity set. */
    OPPORTUNITY_SCRIPTS: 'opportunity-scripts',
    /** Persona opportunity sets grid. */
    PERSONA_OPPORTUNITY_SETS: 'persona-opportunity-sets',
    /** Scripts tab inside a persona opportunity set workspace. */
    PERSONA_SCRIPTS: 'persona-scripts',
} as const;

export type TaskNavigationSection =
    (typeof TASK_NAVIGATION_SECTION)[keyof typeof TASK_NAVIGATION_SECTION];
